module.exports = __webpack_public_path__ + "img/mbti-1.2d336b14.png";